import Vue from 'vue'

const actions = {
  adminLoadAvailableCustomFunctions (context) {
    return Vue.api.get('/admin/custom-functions')
  },

  adminLoadCompanyCustomFunctions (context, companyId) {
    return Vue.api.get('/admin/company-custom-functions', { params: { companyId } })
  },

  adminLoadAllCompanyCustomFunctions (context, params) {
    return Vue.api.get('/admin/company-custom-functions', { params })
  },

  adminCreateCompanyCustomFunction (context, data = {}) {
    return Vue.api.post('/admin/company-custom-functions', { data })
  },

  adminUpdateCompanyCustomFunction (context, { id, ...data }) {
    return Vue.api.patch(`/admin/company-custom-functions/${id}`, { data })
  },

  adminDeleteCompanyCustomFunction (context, id) {
    return Vue.api.delete(`/admin/company-custom-functions/${id}`)
  }
}

export default actions
